import qccapis  from "../../api/qcc";
import apis from "../../api/yj";
import flowapis from "../../api/flow";
import {dateUtils} from "../../utils/dateUtils";
import {utils} from "../../utils/utils";
import vAccount from "../../components/Account.vue";

export default {
    name: "LoanAudit",
    props: {
      visible: {
          type: Boolean, 
          require: false 
      },
      propsOne: String
    },
    data() {
        return {
          accountVisible:false,
          accounttype:1,
            activeName:'first',
            activeNameZx:'first',
            scrollHeight:400,
            query: {
                userName: "",
            },
            isVisible:this.visible,

            //营业信息
            detailResult:{},
            caseResult:["","","",""],
            dataShow:false,
            sxdataList:[],
            sxdata:[],
            sxtype:0,
            labelList:["失信被执行","被执行","严重违法","裁判文书"],
            AllData:[[],[],[],[]],
            pageIndex:1,
            pageSize:10,
            mlShow:false,
            llTableData:[],
            cllTableData:[],
            llListResult:[],
            llShow:false,
            cllShow:false,
            llquery:false,
           
           
            fileList:[[],[],[],[],[],[],[],[],[],[]],
          
            loanAudit:{ContactFlag:"是"},
            myInterval:null,
            bankUserList:[],
            rules_loanAudit: {
               HTBH:[
                { required: true, message: '请填写合同编号', trigger: 'change' }
              ],
               CompanyName:[
                { required: true, message: '请填写企业名称', trigger: 'change' }
              ],
               CompanyCode:[
                { required: true, message: '请填写营业执照号', trigger: 'change' }
              ],
               UserName:[
                { required: true, message: '请填写姓名', trigger: 'change' }
              ],
               IdCard:[
                { required: true, message: '请填写身份证号', trigger: 'change' }
              ],
               POName:[
                { required: true, message: '请填写联系方式', trigger: 'change' }
              ],
               Money:[
                { required: true, message: '请填写申请金额', trigger: 'change' }
              ],

              POName:[
                { required: true, message: '请填写配偶姓名', trigger: 'change' }
              ],
                 POPhone:[
                { required: true, message: '请填写配偶手机号', trigger: 'change' }
              ],
                 POIdCard:[
                { required: true, message: '请填写配偶身份证号', trigger: 'change' }
              ],
                 POAddress:[
                { required: true, message: '请填写配偶地址', trigger: 'change' }
              ],
                UserAddress:[
                { required: true, message: '请填写用户地址', trigger: 'change' }
              ],
                CompanyAddress:[
                { required: true, message: '请填写经营地址', trigger: 'change' }
              ],
              JBYH:[
                { required: true, message: '请填写经办银行', trigger: 'change' }
              ],
              DKHTH:[
                { required: true, message: '请填写贷款合同号', trigger: 'change' }
              ],
              XDHTH:[
                { required: true, message: '请填写贷款合同号', trigger: 'change' }
              ],
              JBYHLXR:[
                { required: true, message: '请填写经办银行联系人', trigger: 'change' }
              ],
              JBYHLXRDH:[
                { required: true, message: '请填写经办银行联系人电话', trigger: 'change' }
              ],
              YHHM:[
                { required: true, message: '请填写银行户名', trigger: 'change' }
              ],
              YHKHH:[
                { required: true, message: '请填写银行开户行', trigger: 'change' }
              ],
              YHZH:[
                { required: true, message: '请填写银行账号', trigger: 'change' }
              ],
              NBZHHM:[
                { required: true, message: '请填写内部账号户名', trigger: 'change' }
              ],
              NBZHKHH:[
                { required: true, message: '请选择内部账号', trigger: 'change' }
              ],
              NBYHZH:[
                { required: true, message: '请选择内部账号', trigger: 'change' }
              ],
               ZDZHHM:[
                { required: true, message: '请填写转贷专户名称', trigger: 'change' }
              ],
              ZDZHKHH:[
                { required: true, message: '请填写转贷专户开户行', trigger: 'change' }
              ],
              ZDYHZH:[
                { required: true, message: '请填写转贷专户账号', trigger: 'change' }
              ],
               ZDYYBHH:[
                { required: true, message: '请填写转贷营业部行号', trigger: 'change' }
              ],
              OldMoney:[
                { required: true, message: '请填写原贷款金额', trigger: 'change' }
              ],
              XDMoney:[
                { required: true, message: '请填写续贷金额', trigger: 'change' }
              ],
              FinalMoney:[
                { required: true, message: '请填写转贷金额', trigger: 'change' }
              ],
              ZDServeMoney:[
                { required: true, message: '请填写综合服务费', trigger: 'change' }
              ],
              SYFL:[
                { required: true, message: '请填写使用费率', trigger: 'change' }
              ],
              YQFL:[
                { required: true, message: '请填写逾期费率', trigger: 'change' }
              ],
              WYFL:[
                { required: true, message: '请填写违约费率', trigger: 'change' }
              ],
              WorkDayNum:[
                { required: true, message: '请填写转贷工作日', trigger: 'change' }
              ],
              LoanEndTime:[
                { required: true, message: '请填写贷款到期时间'}
              ],
              SQDKQX:[
                { required: true, message: '请选择申请贷款期限'}
              ],
              BankFirstUserId:[
                { required: true, message: '请选择银行初审人员'}
              ],
            },
            yjBankList:[],
        };
    },
     components: { vAccount},
    created() {
      // this.getBankList();
    },
    activated() {
    },
    deactivated(){
      let that = this
      if(that.myInterval){
          clearInterval(that.myInterval)
          that.myInterval = null
      }
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
       handleAccount(val) {
            this.accounttype=1;
            this.accountVisible = true;
        },
       handleAccount2(val) {
            this.accounttype=2;
            this.accountVisible = true;
        },
        getAccount(val) {
            this.accountVisible = false;
            if(val){
              if(this.accounttype==1){
                this.loanAudit.NBZHKHH=val.NBZHKHH
                this.loanAudit.NBYHZH=val.NBYHZH
                }else this.loanAudit.JBYHGDKFDH=val.NBYHZH
            }
        },
      changeSQJKQX(){
               if (this.loanAudit.SQJKQX) {
                var date1=new Date(this.loanAudit.SQJKQX[0]);
                var date2=new Date(this.loanAudit.SQJKQX[1]);
                 var diff = Math.abs(date1.getTime() - date2.getTime());
                this.loanAudit.WorkDayNum= Math.floor(diff / (24 * 60 * 60 * 1000))+1;
                this.getZDServeMoney()
              }
      },
      verifyIdCard (val) {
            return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val) // 返回true或false
        },
        verifyPhone (val) {
            return /^1\d{10}$/.test(val) // 返回true或false
        },
        getZDServeMoney(){
            var  money=this.loanAudit.FinalMoney;
            var syfh=this.loanAudit.SYFL;
            if(money&&syfh){
              var money=Math.floor(1000*money*syfh);
              var newmoney=money*1.00/100
              if(this.loanAudit.WorkDayNum){
               newmoney=this.loanAudit.WorkDayNum*money*1.00/100
              }
              this.loanAudit.ZDServeMoney=newmoney;
            }
        },
        selectBank(){
          var that=this;
          var banklist=this.yjBankList;
          for(var i=0;i<banklist.length;i++){
                 if(that.loanAudit.BankID==banklist[i].BankID){
                    that.loanAudit.SYFL=banklist[i].SYFL
                   that.loanAudit.NBZHHM=banklist[i].NBZHHM
                    that.loanAudit.NBZHKHH=banklist[i].NBZHKHH
                    that.loanAudit.NBYHZH=banklist[i].NBYHZH
                       that.loanAudit.ZDZHHM=banklist[i].ZDZHHM
                         that.loanAudit.ZDZHKHH=banklist[i].ZDZHKHH
                          that.loanAudit.ZDZHZH=banklist[i].ZDZHZH
                           that.loanAudit.WorkDayNum=banklist[i].WorkDayNum
                           that.loanAudit.ZDYYBHH=banklist[i].ZDYYBHH
                           that.loanAudit.BankFirstUserId=null;
                          apis.getFirstUserListByIds({Ids:banklist[i].FirstUserIDs}).then(res => {
                                 if(res)this.bankUserList=res;
                           })
                          }
                        }
        },
      getBankList(){
        let param= {
          state: "2",
          pageIndex: 0,
          pageSize: 0
         };
        apis.getBankList(param).then(res => {
         this.bankList=res.list
         })
      },
      onChangeClose(){
        let that = this
        this.isVisible = false
        if(this.myInterval){
          window.clearTimeout(that.myInterval)
          this.myInterval = null
        }
      },
      onChangeOpen(){
        this.isVisible = true
      },

      queryData(row,flag){
        let that = this
        this.dataShow=false;
        if(row){
          that.flowInfo = utils.deepCopy(row)
          if(that.flowInfo.PersonFlag==1){
            that.activeNameZx = 'second'
          }else{
            that.activeNameZx = 'first'
          }
          // 查询营业执照
          const yyzz = qccapis.getCPDetail({id:row.CompanyCode})
          // 诉讼信息
          const ssxx = qccapis.getCPCase({id:row.CompanyCode})
          // 查询土地信息
          const llxx = qccapis.getLL({idCard:row.IdCard})

          // 查询审核信息 
          const shxx = apis.getYjFlowById({
             Id:that.flowInfo.Id,type:1
            }
          )
          
          // const yhxx = apis.getYjBankById({
          //    Id:that.flowInfo.BankID,type:1
          //   })
            const yhxx=apis.getBankList({})
          const fileInfo = flowapis.getLoanFiles({processId:that.flowInfo.Id,type:'',uploadType:'3'})
          var itemStore=null;
          Promise.all([yyzz, ssxx , llxx,shxx,fileInfo,yhxx]).then((res) => {
            if(res.length===6){
              if(res[0]&&res[0]['Result']){
                that.detailResult = res[0]['Result']
              }else{
                that.detailResult = {}
              }
               if(res[2]){
                that.llTableData=res[2].list;
               }
              if(res[3]){
                  that.loanAudit = res[3]
                  if(that.loanAudit.userList){
                    that.bankUserList=that.loanAudit.userList;
                  }
                  if(that.loanAudit.JKTime){
                    that.loanAudit.SQJKQX=[that.loanAudit.JKTime,that.loanAudit.JKEndTime]
                  }
                  that.loanAudit.BankID+="";
                  if(that.loanAudit.Route==1){//审核获取本地数据
                    itemStore = that.getSaveItems('loanAudit')
                    if(itemStore)that.loanAudit=itemStore;
                  }
              }
              if(res[4]){
                var oldfilelist=res[4];
                var fileList=[[],[],[],[],[],[],[],[],[],[]];
                  for(let f=0;f<oldfilelist.length;f++){
                    var idx=oldfilelist[f].FileIndex;
                    fileList[idx].push({
                      name:oldfilelist[f]['Name'],
                      url:oldfilelist[f]['Url']
                    })
                  }
                  if(fileList[6].length==0&&that.loanAudit.FrontImg!=null){
                    fileList[6].push({
                      name:"身份证正面照",
                      url:that.loanAudit.FrontImg
                    })
                    fileList[6].push({
                      name:"身份证反面照",
                      url:that.loanAudit.BackImg
                    })
                  }
                  that.fileList=fileList;
                  if(that.loanAudit.Route==1){//审核获取本地数据
                    itemStore = that.getSaveItems('fileList')
                    if(itemStore)that.fileList=itemStore;
                  }
               }
                 if(res[5]){
                   var banklist=res[5].list;
                    for(var i=0;i<banklist.length;i++){
                      if(that.loanAudit.BankID==banklist[i].BankID){
                    if(!that.loanAudit.SYFL)that.loanAudit.SYFL=banklist[i].SYFL
                   if(!that.loanAudit.NBZHHM)that.loanAudit.NBZHHM=banklist[i].NBZHHM
                    if(!that.loanAudit.NBZHKHH)that.loanAudit.NBZHKHH=banklist[i].NBZHKHH
                     if(!that.loanAudit.NBYHZH)that.loanAudit.NBYHZH=banklist[i].NBYHZH
                      // if(!that.loanAudit.YQFL)that.loanAudit.YQFL=banklist[i].YQFL
                      //  if(!that.loanAudit.WYFL)that.loanAudit.WYFL=banklist[i].WYFL
                        if(!that.loanAudit.ZDZHHM)that.loanAudit.ZDZHHM=banklist[i].ZDZHHM
                         if(!that.loanAudit.ZDZHKHH)that.loanAudit.ZDZHKHH=banklist[i].ZDZHKHH
                          if(!that.loanAudit.ZDZHZH)that.loanAudit.ZDZHZH=banklist[i].ZDZHZH
                           if(!that.loanAudit.WorkDayNum)that.loanAudit.WorkDayNum=banklist[i].WorkDayNum
                           if(!that.loanAudit.ZDYYBHH)that.loanAudit.ZDYYBHH=banklist[i].ZDYYBHH
                      }
                    }
                 that.yjBankList=banklist;
                 }
              var qccres=res[1];
              if(qccres){
                that.sxdata=res;
              for(var i=0;i<4;i++){
                  if(Number(qccres[i].Status)==200){
                    if(qccres[i].Result.VerifyResult==0)that.caseResult[i]=0;
                    else {
                      if(i<2)that.caseResult[i] = qccres[i].Paging.TotalRecords;
                      if(i==2)that.caseResult[i]=qccres[i].Result.Data.length;
                      if(i==3){
                        that.caseResult[i] = qccres[i].Paging.TotalRecords;
                       var datalist=qccres[3].Result.Data;
                        for(var j=0;j<datalist.length;j++){
                          var roletype="";
                          if(datalist[j].IsProsecutor)roletype="原告";
                          if(datalist[j].IsDefendant)roletype="被告";
                          datalist[j].RoleType=roletype;
                          var partylist=datalist[j].PartyList;
                          for(var k=0;k<partylist.length;k++){
                             if(partylist[k].RoleType==roletype){
                              datalist[j].Statement=partylist[k].Statement
                             }
                          }
                        }
                      }
                      that.AllData[i]=that.AllData[i].concat(qccres[i].Result.Data);
                      if(!that.dataShow){
                           that.dataShow=true;
                           that.sxtype=i;
                           that.sxdataList=that.getlistten(qccres[i].Result.Data,1,10);
                           if(that.caseResult[i]>10)that.mlShow=true;
                      }

                    }
                }else{
                  that.caseResult[i]="";
                }
               }
              }
            }
            
        if (this.$refs.ruleForm !== undefined) this.$refs.ruleForm.resetFields();
            that.timeOutSave()
          })
        }
      },
      beforeAvatarFileUpload(file) {
        let that = this
        const isLt2M = file.size/1024/1024 <10
        if(!isLt2M){
            that.$message.error("上传文件大小不能超过10MB") 
            return false 
        }
        return true
      },
      uploadFileFile_FJ(item){
        let that = this
        let idx=item.data;
        let fileObj = item.file
        const form = new FormData()
        form.append("file",fileObj)
        apis.uploadFile(form).then(res => {
            that.fileList[idx].push({
              name: fileObj.name,
              url:res.fullPath
            })
        });
      },
      getFileName(path){
        var pos1 = path.lastIndexOf('/');
        var pos2 = path.lastIndexOf('\\');
        var pos  = Math.max(pos1, pos2)
        if( pos<0 )
            return path;
        else
            return path.substring(pos+1);
      },
      handleFileRemove_FJ(file) {
        let that = this
        if(file){
          for(let i=0;i<that.fileList.length;i++){
            for(let j=0;j<that.fileList[i].length;j++){
              if(file.url===that.fileList[i][j].url){
                that.fileList[i].splice(j,1)
              }
            }
            
          }
        }
      },
      handleFileView(file){
            window.open(file.url);
      },
      handleExceed(){
        this.$message.error("数量超出限制，请先移除原有文件");
      },

      /**
       * 保存文件
       */
      saveFjFileInfo(callback){
        let that = this
        let filesLists = []
        for(var i=0;i<that.fileList.length;i++){
          for(var j=0;j<that.fileList[i].length;j++){
 
            let fileInfo = {
              ProcessId:that.flowInfo.Id,
              Type:'2',
              Url:that.fileList[i][j]['url'],
              Name:that.fileList[i][j]['name'],
              UploadType:3,
              FileIndex:i,
            }
            if(this.isImage(fileInfo.Url))fileInfo.Type="1";
            filesLists.push(fileInfo)
          }
        }
        if(filesLists.length>0){
          flowapis.addLoanFile({fileList:filesLists}).then(res => {
            callback(res)
          })
        }else{
            flowapis.deleteLoanFile({ProcessId:that.flowInfo.Id,UploadType:3}).then(res => {
            callback(res)
          })
        }
      },
      isImage(filename) {
      const extension = filename.split(".").pop().toLowerCase();
      const imageExtensions = ['jpg','jpeg','png','gif','jmp','webp','svg'];
           return imageExtensions.includes(extension);
          },
      // 信用相关
      queryClick(flag){
        this.dataShow=true;
        this.sxtype=flag;
        if(this.caseResult[flag]>10)this.mlShow=true;
        else this.mlShow=false;
        this.pageIndex=1;
        this.sxdataList=this.getlistten(this.AllData[flag],1,10);
      },
      getlistten(list,pageIndex,pageSize){
        var newlist=[]
        for(var i=0;i<pageSize;i++){
          var j=i+(pageIndex-1)*pageSize;
          if(j<list.length)newlist.push(list[j]);
        }
        return newlist;
      },
      getList(flag){
        var type=this.sxtype;
        var that=this;
        var pageIndex=this.pageIndex+flag;
        if(pageIndex<1){that.$message.info("已经是第一页");return;}
        var allPage=(this.caseResult[this.sxtype]+9)/10;
        if(pageIndex>allPage){that.$message.info("已经是最后一页");return;};
        if(this.sxtype==2){
          this.pageIndex=pageIndex;
          this.sxdataList=this.getlistten(this.AllData[type],pageIndex,10);
        }else{
          let param1 = {
              id:that.flowInfo.Code,
              pageIndex:Math.ceil(pageIndex/2),
              type:Number(type)+1
           }
           
           qccapis.getCPCaseByType(param1).then(res => {
          if(res!=null){
            if(Number(res.Status)==200){
                var datalist=res.Result.Data;
                if(type==3){
                  for(var j=0;j<datalist.length;j++){
                    var roletype="";
                    if(datalist[j].IsProsecutor)roletype="原告";
                    if(datalist[j].IsDefendant)roletype="被告";
                    datalist[j].RoleType=roletype;
                    var partylist=datalist[j].PartyList;
                    for(var k=0;k<partylist.length;k++){
                       if(partylist[k].RoleType==roletype){
                        datalist[j].Statement=partylist[k].Statement
                       }
                    }
                  }
                }
                var danwei=pageIndex%2;
                if(danwei==0)danwei=2;
                that.pageIndex=pageIndex;
                var list=that.getlistten(res.Result.Data,danwei,10);
                that.sxdataList=list;
              }else{
               that.$message.error(res[i].Message)
              }
            }else{
             that.$message.error("查询信息失败")
           }
            });


        }
      },
      /**
       * 暂存在本地缓存中
       */
      onSaveLocalStore(){
        let that = this
        that.dynamicSaveItems()
      },

      /**
       * 银行拒绝
       * 
       */
      onReturnFlow(){
        let that = this
        this.$prompt('', '必须填写拒绝的原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '必须填写原因',
          inputValidator:(value)=>{
            if(value.trim().length<1){
              return false
            }
          },
          beforeClose: (action, instance, done)=>{
            if(action == 'confirm'){
                let value = instance.inputValue
                if(value.length>200){
                  that.$message({
                    message: '文本应不超过200字',
                    type: "error"
                  });
                  return
                }
                if(value && value != ''){
                  let param = {
                    Id:that.flowInfo.Id,
                    State:3,
                    Route:that.flowInfo.Route,
                    RefuseReason:value,
                  }
                  apis.updateYjFlow(param).then((res) => {
                    if(res){
                      done()
                    }else{
                      that.$message({
                        message: '拒绝失败请重试',
                        type: "error"
                      });
                    }
                  })
                }
            }else{
              done()
            }
          }
        }).then(({ value }) => {
            // that.$emit('bankauditsucess');
            if(that.myInterval){
                window.clearTimeout(that.myInterval)
                that.myInterval = null
            }
            that.removeSaveItem()
            that.onChangeClose()
            this.$parent.bankAuditSucess();
        }).catch(() => {
               
        });
      },

      setObjEmptyToNull(obj){
        Object.keys(obj).forEach(function(key, index) {
          if (this[key] === '') this[key] = null;
        }, obj);
        return obj
      },

      /**
       * 审核通过
       */
      onPassFlow(){
        let that = this
        that.$refs["ruleForm"].validate((valid) => {
          if (valid) {
           if(!this.verifyPhone(that.loanAudit.Phone)){
               that.$message({
            message: '联系方式格式有误',
            type: 'warning'
          });
          return
            }
            if(!this.verifyIdCard(that.loanAudit.IdCard)){
               that.$message({
            message: '身份证号格式有误',
            type: 'warning'
            });
            return
            }
            if(that.loanAudit.PersonFlag==1){
              if(that.loanAudit.POName){
                   if(!this.verifyPhone(that.loanAudit.POPhone)){
               that.$message({
            message: '配偶联系方式格式有误',
            type: 'warning'
          });
          return
            }
            if(!this.verifyIdCard(that.loanAudit.POIdCard)){
               that.$message({
            message: '配偶身份证号格式有误',
            type: 'warning'
            });
            return
            }
              }else{
                that.loanAudit.POName=""
                that.loanAudit.POAddress=""
                that.loanAudit.POIdCard=""
                that.loanAudit.POPhone=""
              }          
            }else{
                if(that.loanAudit.CompanyCode.length!=15&&that.loanAudit.CompanyCode.length!=18){
                  that.$message({
               message: '营业执照号格式有误',
               type: 'warning'
               });
                return
                }
            }
            if(that.loanAudit.FinalMoney>9999){
                that.$message({
               message: '转贷金额超过1亿',
               type: 'warning'
               });
                return
            }

              let loanAuditPara = utils.deepCopy(that.loanAudit);
              loanAuditPara.State=1;
              loanAuditPara.Route=2
              if (that.loanAudit.SQJKQX) {
                loanAuditPara.JKTime = dateUtils.dateToStr("yyyy-MM-dd",new Date(that.loanAudit.SQJKQX[0]))
                loanAuditPara.JKEndTime= dateUtils.dateToStr("yyyy-MM-dd",new Date(that.loanAudit.SQJKQX[1]))
              }else{
                 that.$message({
            message: '请选择借款期限',
            type: 'warning'
          });
          return
              }
              for(var i=0;i<that.bankUserList.length;i++){
                if(that.bankUserList[i].UserID==that.loanAudit.BankFirstUserId){
                  loanAuditPara.JBYHLXR=that.bankUserList[i].UserName
                  loanAuditPara.JBYHLXRDH=that.bankUserList[i].Tel
                }
              }
              if(!loanAuditPara.JBYHLXRDH){that.$message({
                message: '银行经办人电话获取失败',
                 type: 'warning'
                    });return;
                  }
              delete loanAuditPara.SQJKQX;
              that.saveFjFileInfo(function(flag){
                if(!flag){
                  this.$message.error("附件保存失败");
                }else{
                  apis.updateYjFlow(loanAuditPara).then((res) => {
                    if(res){
                           if(res=="success"){
                            if(that.myInterval){
                               clearInterval(that.myInterval)
                                 that.myInterval = null
                                }
                             that.removeSaveItem()
                                 that.onChangeClose()
                                that.$parent.bankAuditSucess();
         
                            }else{
                         that.$message({
                         message: res,
                         type: "error"
                           });
                              }
                    }else{
                      that.$message.error("录入数据失败");
                    }
                  })
                }
              })
          } else {
            that.$message({
            message: '有必填项未处理，请检查',
            type: 'warning'
          });
            return false;
          }
        });
        
      },
      calcTableHeight(){
        this.$nextTick(() => {
          var height1=$(".content-box .content").height();
          var height=height1-50-20-40-20;
          this.scrollHeight = height;
        });
      },
      dynamicSaveItems(){
        let that = this
        let saveObj = {
          loanAudit:that.loanAudit,
          fileList:that.fileList,
        }
        if(that.flowInfo&&that.flowInfo.Id){
          // flowId_userId_type_router
          localStorage.setItem(that.flowInfo.Id+'_yjflow', JSON.stringify(saveObj))
        }
      },
      getSaveItems(name){
        let that = this
        let result = null
        let key = that.flowInfo.Id+'_yjflow'
        if(localStorage.getItem(key)){
          let items = JSON.parse(localStorage.getItem(key))
          if(items){
            switch(name){
                case 'loanAudit':
                  if(items.loanAudit){
                    result = items.loanAudit
                  }
                  break;
                  case 'fileList':
                    if(items.fileList){
                      result = items.fileList
                    }
                  break;
            }
          }
        }
        return result
      },
      timeOutSave(){
        let that = this
        if(that.myInterval){
            clearInterval(that.myInterval)
            that.myInterval = null
        }
        that.myInterval = window.setInterval(() => {
            setTimeout(() => {
              that.dynamicSaveItems()
            }, 1)
        }, 3000);
      },
      removeSaveItem(){
        let that = this
        let key = that.flowInfo.Id+'_yjflow'
        localStorage.removeItem(key);
      },
    },
  };
